(function () {
  const drawer = document.getElementById('wc-drawer');
  const openBtn = document.querySelector('.wc-header__menu-open');
  const desktopNavQuery = window.matchMedia('(min-width: 990px)');

  if (drawer) {
    const closeEls = drawer.querySelectorAll('[data-wc-drawer-close]');
    const rootView = drawer.querySelector('[data-wc-drawer-view="root"]');
    const subViews = drawer.querySelectorAll('[data-wc-drawer-view]:not([data-wc-drawer-view="root"])');
    const gotoBtns = drawer.querySelectorAll('[data-wc-drawer-goto]');
    const backBtns = drawer.querySelectorAll('[data-wc-drawer-back]');
    const panel = drawer.querySelector('.wc-drawer__panel');
    const closeBtn = drawer.querySelector('.wc-drawer__close');
    const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    let launcher = null;

    function focusables() {
      if (!panel) return [];
      return Array.prototype.filter.call(panel.querySelectorAll(FOCUSABLE), function (el) {
        return !el.closest('[hidden]') && el.getClientRects().length > 0;
      });
    }

    function focusEl(el) {
      if (el) el.focus({ preventScroll: true });
    }

    function openDrawer() {
      launcher = document.activeElement instanceof HTMLElement ? document.activeElement : openBtn;
      drawer.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      drawer.classList.add('is-open');
      document.body.classList.add('wc-drawer-open');
      openBtn?.setAttribute('aria-expanded', 'true');
      showView('root');
      focusEl(closeBtn || focusables()[0]);
    }

    function closeDrawer() {
      if (!drawer.classList.contains('is-open')) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('wc-drawer-open');
      openBtn?.setAttribute('aria-expanded', 'false');
      window.setTimeout(function () {
        if (!drawer.classList.contains('is-open')) drawer.hidden = true;
      }, 260);
      showView('root');
      focusEl(launcher && document.contains(launcher) ? launcher : openBtn);
      launcher = null;
    }

    function showView(name, focusTarget) {
      if (rootView) rootView.hidden = name !== 'root';
      subViews.forEach(function (view) {
        view.hidden = view.getAttribute('data-wc-drawer-view') !== name;
      });
      if (focusTarget) focusEl(focusTarget);
    }

    openBtn?.addEventListener('click', openDrawer);
    closeEls.forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });

    gotoBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const name = btn.getAttribute('data-wc-drawer-goto');
        const view = drawer.querySelector('[data-wc-drawer-view="' + name + '"]');
        showView(name, view ? view.querySelector('[data-wc-drawer-back]') : null);
      });
    });

    backBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const name = btn.closest('[data-wc-drawer-view]')?.getAttribute('data-wc-drawer-view');
        const parentBtn = name ? drawer.querySelector('[data-wc-drawer-goto="' + name + '"]') : null;
        showView('root', parentBtn);
      });
    });

    drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !drawer.classList.contains('is-open')) return;
      const items = focusables();
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (e.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) {
        e.preventDefault();
        focusEl(last);
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        focusEl(first);
      }
    });

    document.addEventListener('focusin', function (e) {
      if (drawer.classList.contains('is-open') && panel && !panel.contains(e.target)) {
        focusEl(closeBtn || focusables()[0]);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
  }

  /* Desktop dropdown navigation */
  const navItems = document.querySelectorAll('[data-wc-nav-dropdown]');
  if (!navItems.length) return;

  let closeTimer = null;
  let openItem = null;
  const CLOSE_DELAY_MS = 150;

  function getPanel(item) {
    const panelId = item.getAttribute('data-wc-nav-panel-id');
    return panelId ? document.getElementById(panelId) : item.querySelector('.wc-header__dropdown');
  }

  function getTrigger(item) {
    return item.querySelector('.wc-header__nav-trigger');
  }

  function openDropdown(item) {
    if (!desktopNavQuery.matches) return;
    const btn = getTrigger(item);
    const panel = getPanel(item);
    if (!btn || !panel) return;

    navItems.forEach(function (other) {
      if (other === item) return;
      const otherBtn = getTrigger(other);
      const otherPanel = getPanel(other);
      if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
      if (otherPanel) otherPanel.hidden = true;
    });

    btn.setAttribute('aria-expanded', 'true');
    panel.hidden = false;
    openItem = item;
  }

  function closeDropdown(item, focusTrigger) {
    const btn = getTrigger(item);
    const panel = getPanel(item);
    if (btn) btn.setAttribute('aria-expanded', 'false');
    if (panel) panel.hidden = true;
    if (openItem === item) openItem = null;
    if (focusTrigger && btn) btn.focus();
  }

  function closeAllDropdowns(restoreFocus) {
    var focusBtn = restoreFocus && openItem ? getTrigger(openItem) : null;
    navItems.forEach(function (item) {
      closeDropdown(item, false);
    });
    openItem = null;
    if (focusBtn) focusBtn.focus();
  }

  function cancelScheduledClose() {
    if (closeTimer !== null) {
      window.clearTimeout(closeTimer);
      closeTimer = null;
    }
  }

  function scheduleClose(item) {
    cancelScheduledClose();
    closeTimer = window.setTimeout(function () {
      closeDropdown(item, false);
    }, CLOSE_DELAY_MS);
  }

  function toggleDropdown(item) {
    const btn = getTrigger(item);
    const panel = getPanel(item);
    if (!btn || !panel) return;
    const isOpen = btn.getAttribute('aria-expanded') === 'true';
    if (isOpen) {
      closeDropdown(item, false);
    } else {
      openDropdown(item);
    }
  }

  navItems.forEach(function (item) {
    const btn = getTrigger(item);
    const panel = getPanel(item);
    if (!btn || !panel) return;

    btn.addEventListener('click', function () {
      toggleDropdown(item);
    });

    btn.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggleDropdown(item);
      }
      if (e.key === 'Escape') {
        closeDropdown(item, true);
      }
    });

    item.addEventListener('mouseenter', function () {
      if (!desktopNavQuery.matches) return;
      cancelScheduledClose();
      openDropdown(item);
    });

    item.addEventListener('mouseleave', function () {
      if (!desktopNavQuery.matches) return;
      scheduleClose(item);
    });

    panel.addEventListener('mouseenter', function () {
      if (!desktopNavQuery.matches) return;
      cancelScheduledClose();
      openDropdown(item);
    });

    panel.addEventListener('mouseleave', function () {
      if (!desktopNavQuery.matches) return;
      scheduleClose(item);
    });
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-wc-nav-dropdown]') && !e.target.closest('.wc-header__dropdown')) {
      closeAllDropdowns(false);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllDropdowns(true);
  });
})();
